module.exports = __webpack_public_path__ + "static/media/37-6.57e90313.mp3";